var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEinbruchschutz = function SvgEinbruchschutz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.127,
    height: 88.51
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "einbruchschutz_svg__c",
    x1: 44.16,
    x2: 28.293,
    y1: 35.4,
    y2: 51.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59797f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a0b2b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "einbruchschutz_svg__d",
    x1: 34.559,
    x2: 25.533,
    y1: 28.19,
    y2: 52.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "einbruchschutz_svg__a",
    x1: 27.112,
    x2: 45.863,
    y1: 37.381,
    y2: 50.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f4f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4f4f8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#einbruchschutz_svg__a",
    id: "einbruchschutz_svg__e",
    x1: 30.814,
    x2: 41.021,
    y1: 31.467,
    y2: 39.52
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "einbruchschutz_svg__b",
    x1: -2.164,
    x2: 9.306,
    y1: 31.863,
    y2: 33.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#einbruchschutz_svg__b",
    id: "einbruchschutz_svg__f",
    x1: 60.837,
    x2: 67.853,
    y1: 42.814,
    y2: 43.841
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#einbruchschutz_svg__b",
    id: "einbruchschutz_svg__g",
    x1: 23.276,
    x2: 46.605,
    y1: 34.123,
    y2: 37.541
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#einbruchschutz_svg__b",
    id: "einbruchschutz_svg__h",
    x1: 4.908,
    x2: 27.146,
    y1: 31.954,
    y2: 35.211
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#einbruchschutz_svg__b",
    id: "einbruchschutz_svg__i",
    x1: 40.752,
    x2: 59.825,
    y1: 38.506,
    y2: 41.3
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc8cc",
    d: "M35.563 88.51S53.2 73.588 59.513 66.118c9.008-10.651 13.495-42.895 10.87-56.575L35.563 0 .744 9.554c-2.625 13.67 1.861 45.913 10.87 56.564 6.313 7.47 23.95 22.392 23.95 22.392"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "M34.963 80.023c-5.313-4.655-14.81-13.155-18.74-17.79C9.728 54.55 5.183 29.403 6.156 14.968l.044-.646 29.364-8.062 29.365 8.051.044.646c.973 14.433-3.572 39.58-10.068 47.263C50.71 67.18 40.4 76.324 36.162 80.024l-.6.524Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M35.563 79.338c-6.058-5.308-14.9-13.277-18.644-17.693-6.37-7.534-10.8-32.6-9.855-46.617l28.5-7.824 28.499 7.814c.945 14.016-3.49 39.083-9.855 46.613-3.747 4.434-12.587 12.417-18.645 17.707"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruchschutz_svg__c)",
    d: "M46.448 38.466h-1.892v-4.07a8.998 8.998 0 0 0-17.985 0v4.07h-1.892a1.627 1.627 0 0 0-1.628 1.625v13.323a1.63 1.63 0 0 0 1.628 1.628h21.769a1.63 1.63 0 0 0 1.628-1.628V40.091a1.627 1.627 0 0 0-1.628-1.625m-4.894 0H29.573v-4.07a5.998 5.998 0 0 1 11.98 0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruchschutz_svg__d)",
    d: "M24.341 54.41V41.087a1.626 1.626 0 0 1 1.628-1.626h1.892v-4.07a8.856 8.856 0 0 1 8.994-8.69 9.16 9.16 0 0 1 4.929 1.428 9.12 9.12 0 0 0-6.22-2.423 8.856 8.856 0 0 0-8.993 8.69v4.07h-1.892a1.627 1.627 0 0 0-1.628 1.625v13.323a1.63 1.63 0 0 0 1.412 1.612 1.6 1.6 0 0 1-.122-.616"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruchschutz_svg__a)",
    d: "M35.563 26.202a8.357 8.357 0 0 1 8.494 8.194v4.566h2.39a1.13 1.13 0 0 1 1.13 1.13v13.322a1.13 1.13 0 0 1-1.13 1.13H24.68a1.13 1.13 0 0 1-1.13-1.13V40.092a1.13 1.13 0 0 1 1.13-1.13h2.39v-4.566a8.357 8.357 0 0 1 8.493-8.194m0-.498a8.855 8.855 0 0 0-8.991 8.692v4.068H24.68a1.63 1.63 0 0 0-1.628 1.628v13.322a1.63 1.63 0 0 0 1.628 1.627h21.767a1.63 1.63 0 0 0 1.628-1.627V40.092a1.63 1.63 0 0 0-1.628-1.628h-1.892v-4.068a8.855 8.855 0 0 0-8.992-8.692"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruchschutz_svg__e)",
    d: "M35.565 28.705a5.85 5.85 0 0 1 5.989 5.69v4.07H29.573v-4.07a5.853 5.853 0 0 1 5.992-5.69m0-.455a6.31 6.31 0 0 0-6.448 6.146v4.525H42.01v-4.525a6.31 6.31 0 0 0-6.444-6.146"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruchschutz_svg__b)",
    d: "M6.04 20.696a561 561 0 0 1-6.038-1.502 123.2 123.2 0 0 0 3.162 26.437q3.008-.875 5.873-1.501a120 120 0 0 1-2.996-23.434",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruchschutz_svg__f)",
    d: "M64.416 30.404a108.8 108.8 0 0 1-4.908 22.776 56 56 0 0 1 4.936 4.035c2.997-7.566 5.084-17.54 6.057-26.859a77 77 0 0 1-6.085.048",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f8",
    d: "m17.105 63.235-.15-.168c-.26-.288-.507-.57-.731-.833C9.727 54.55 5.182 29.402 6.155 14.967l.044-.646L34.286 6.61 6.018 13.662l-.468.128-.033.485-.043.646C4.492 29.477 9.11 54.88 15.702 62.675a68 68 0 0 0 6.065 5.32c-1.786-1.729-3.402-3.367-4.662-4.76"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruchschutz_svg__g)",
    d: "M47.39 38.77a1.6 1.6 0 0 0-.943-.306h-1.891v-4.068a8.4 8.4 0 0 0-1.357-4.552 415 415 0 0 1-13.155-2.28 8.8 8.8 0 0 0-1.837 1.85 8.44 8.44 0 0 0-1.636 4.982v4.068H24.68a1.63 1.63 0 0 0-1.63 1.627v.88q1.06-.033 2.11-.035a60 60 0 0 1 22.916 4.371v-5.216a1.62 1.62 0 0 0-.685-1.321m-5.836-.304H29.573v-4.07a5.4 5.4 0 0 1 .724-2.711 5.85 5.85 0 0 1 1.92-2.007 6 6 0 0 1 1.018-.525 6.28 6.28 0 0 1 4.659 0 6 6 0 0 1 1.017.525 5.85 5.85 0 0 1 1.92 2.007 5.43 5.43 0 0 1 .723 2.71Z",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruchschutz_svg__h)",
    d: "M23.05 40.091a1.63 1.63 0 0 1 1.63-1.627h1.89v-4.068a8.44 8.44 0 0 1 1.637-4.982 9 9 0 0 1 2.625-2.385C21.96 25.34 13.537 23.437 6.99 21.862a122 122 0 0 0 2.743 21.195 77 77 0 0 1 13.319-1.63Z",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruchschutz_svg__i)",
    d: "M42.65 29.08c.146.18.295.36.426.553a8.43 8.43 0 0 1 1.48 4.763v4.068h1.891a1.64 1.64 0 0 1 1.629 1.627v5.672A56.8 56.8 0 0 1 59.05 51.73a110.3 110.3 0 0 0 4.335-20.452A186 186 0 0 1 42.65 29.08",
    style: {
      mixBlendMode: "soft-light"
    }
  }))));
};
export default SvgEinbruchschutz;